import api from './';

export default {
  getParameter(args) {
    return api.post('Parameters/Get', { parameterId: args }).then(response => response.data);
  },

  getDefaultParameters() {
    return api.post('Parameters/GetDefault', {}).then(response => response.data);
  },

  saveParameters(args) {
    return api.post('Parameters/Save', { parameter: args }).then(response => response.data);
  },

  searchParameters(args) {
    return api.post('Parameters/Search', { search: args }).then(response => response.data);
  },
};
